
<div class="modal-body px-md-3 py-md-2">
  <div class="d-flex justify-content-between align-items-center">
    <div class="min-width-left">
      <p (click)="close()" class="text-center mb-0 cursor-pointer">
        <i class="fa fa-chevron-left mr-1 text-muted" aria-hidden="true"></i>
        <span class="text-black">Back</span>
      </p>
    </div>
    <button (click)="launchHelpModal()" class="btn btn-sm text-black font-weight-bolder" style="border: 1px solid #DDDEDD; background: #FCFCFC">
      Need Help <img src="../../../../../assets/img/help.svg" style="height: 22px;" alt="">
    </button>
  </div>

  <h2 class="font-weight-bolder text-black mt-4 mb-0">Create an Account</h2>
  <p class="mb-3">Simply fill out the form below to get started</p>

  <form class="auth-register-form" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
    <div *ngIf="error" class="alert alert-danger py-1 px-2">{{ error }}</div>
    <div *ngIf="success" class="alert alert-success py-2">Registration successful! Redirecting...</div>

    <div class="form-group">
      <label for="mawingu-register-name" class="form-label text-black">Please enter your Full Name</label>
      <input type="text" id="mawingu-register-name" formControlName="name" class="form-control"
        placeholder="enter name" tabindex="1" autofocus
        [ngClass]="{ 'is-invalid': registerForm.get('name')?.touched && registerForm.get('name')?.errors }" />
      <div *ngIf="registerForm.get('name')?.touched && registerForm.get('name')?.errors" class="invalid-feedback">
        <div *ngIf="registerForm.get('name')?.errors?.required">Name is required</div>
      </div>
    </div>

    <div class="form-group">
      <label for="mawingu-register-email" class="form-label text-black">Please provide your email (optional)</label>
      <input type="email" id="mawingu-register-email" formControlName="email" class="form-control"
        placeholder="example@gmail.com" tabindex="2" />
      <small class="text-black">Will use this in case of password resetting</small>
    </div>

    <div class="form-group">
      <label for="mawingu-education-system" class="form-label text-black">Education system</label>
      <select id="mawingu-education-system" formControlName="educationSystem" class="form-control"
        [ngClass]="{ 'is-invalid': registerForm.get('educationSystem')?.touched && registerForm.get('educationSystem')?.errors }">
        <option value="" disabled selected>Select your education system</option>
        <option *ngFor="let curriculum of ['CBC', 'KCSE']" [ngValue]="curriculum">{{ curriculum }}</option>
      </select>
      <div *ngIf="registerForm.get('educationSystem')?.touched && registerForm.get('educationSystem')?.errors" class="invalid-feedback">
        <div *ngIf="registerForm.get('educationSystem')?.errors?.required">Curriculum is required</div>
      </div>
    </div>

    <div class="form-group" *ngIf="registerForm.get('educationSystem')?.value === 'CBC'">
      <label for="mawingu-grade" class="form-label">Grade</label>
      <select id="mawingu-grade" formControlName="grade" class="form-control"
        [ngClass]="{ 'is-invalid': registerForm.get('grade')?.touched && registerForm.get('grade')?.errors }">
        <option value="" disabled selected>Select a Grade</option>
        <option *ngFor="let grade of cbcGrades" [ngValue]="grade.gradeId">{{ grade.gradeName }}</option>
      </select>
      <div *ngIf="registerForm.get('grade')?.touched && registerForm.get('grade')?.errors" class="invalid-feedback">
        <div *ngIf="registerForm.get('grade')?.errors?.required">Grade is required</div>
      </div>
    </div>

    <div class="form-group">
      <label for="mawingu-register-password" class="form-label text-black">Please enter your password</label>
      <div class="input-group input-group-merge form-password-toggle">
        <input [type]="passwordTextType ? 'text' : 'password'" id="mawingu-register-password"
          formControlName="password" class="form-control form-control-merge" placeholder="password"
          tabindex="3" [ngClass]="{ 'is-invalid error': registerForm.get('password')?.touched && registerForm.get('password')?.errors }" />
        <div class="input-group-append">
          <span class="input-group-text cursor-pointer">
            <i class="feather font-small-4" [ngClass]="{ 'icon-eye-off': passwordTextType, 'icon-eye': !passwordTextType }"
              (click)="togglePasswordTextType()"></i>
          </span>
        </div>
      </div>
      <small class="text-black">Minimum of 5 characters</small>
      <div *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.errors" class="invalid-feedback d-block">
        <div *ngIf="registerForm.get('password')?.errors?.required">Password is required</div>
      </div>
    </div>

    <div class="form-group">
      <label for="mawingu-register-confirm-password" class="form-label text-black">Confirm your new password</label>
      <div class="input-group input-group-merge form-password-toggle">
        <input [type]="passwordTextType2 ? 'text' : 'password'" id="mawingu-register-confirm-password"
          formControlName="confirmPassword" class="form-control form-control-merge" placeholder="password"
          tabindex="4" [ngClass]="{ 'is-invalid error': registerForm.get('confirmPassword')?.touched && registerForm.hasError('mismatch') }" />
        <div class="input-group-append">
          <span class="input-group-text cursor-pointer">
            <i class="feather font-small-4" [ngClass]="{ 'icon-eye-off': passwordTextType2, 'icon-eye': !passwordTextType2 }"
              (click)="togglePasswordTextType2()"></i>
          </span>
        </div>
      </div>
      <small class="text-black">Minimum of 5 characters</small>
      <div *ngIf="registerForm.get('confirmPassword')?.touched && registerForm.hasError('mismatch')" class="invalid-feedback d-block">
        Password does not match
      </div>
    </div>

    <app-terms-and-conditions (childMethodEvt)="getAcceptedTermsStatus($event)"></app-terms-and-conditions>

    <button [disabled]="loading || !agreedToTerms || !registerForm.valid" class="btn btn-primary mb-1  btn-block" tabindex="5">
      <span *ngIf="!loading">Proceed to Sign in</span>
      <span *ngIf="loading" class="spinner-border spinner-border-sm"></span>
    </button>
  </form>
</div>